// Community / Messaging API client (Phase A — public groups; Phase B — DMs later).
import axios from "axios";
import { API } from "@/App";

const auth = (token) => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

export const communityApi = {
  // Groups
  groups:        (token)              => axios.get(`${API}/community/groups`, auth(token)).then(r => r.data),
  groupDetail:   (slug, token)        => axios.get(`${API}/community/groups/${slug}`, auth(token)).then(r => r.data),

  // Messages
  list:    (slug, token, before)      => axios.get(`${API}/community/groups/${slug}/messages${before ? `?before=${encodeURIComponent(before)}` : ""}`, auth(token)).then(r => r.data),
  send:    (slug, body, token)        => axios.post(`${API}/community/groups/${slug}/messages`, body, auth(token)).then(r => r.data),
  edit:    (messageId, body, token)   => axios.put(`${API}/community/messages/${messageId}`, body, auth(token)).then(r => r.data),
  remove:  (messageId, token)         => axios.delete(`${API}/community/messages/${messageId}`, auth(token)).then(r => r.data),
  react:   (messageId, emoji, token)  => axios.post(`${API}/community/messages/${messageId}/react`, { emoji }, auth(token)).then(r => r.data),
  pin:     (messageId, token)         => axios.post(`${API}/community/messages/${messageId}/pin`, {}, auth(token)).then(r => r.data),
  report:  (messageId, reason, token) => axios.post(`${API}/community/messages/${messageId}/report`, { reason, note: "" }, auth(token)).then(r => r.data),

  // Per-thread controls
  markRead: (slug, token)             => axios.post(`${API}/community/groups/${slug}/read`, {}, auth(token)).then(r => r.data),
  toggleMute: (slug, token)           => axios.post(`${API}/community/groups/${slug}/mute`, {}, auth(token)).then(r => r.data),
  search:   (slug, q, token)          => axios.get(`${API}/community/groups/${slug}/search?q=${encodeURIComponent(q)}`, auth(token)).then(r => r.data),

  // File upload (image / voice / pdf)
  upload:  (file, token) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/community/upload`, fd, {
      headers: { ...auth(token).headers, "Content-Type": "multipart/form-data" },
    }).then(r => r.data);
  },

  // Phase B — Friends
  searchUsers:    (q, token)            => axios.get(`${API}/community/users/search?q=${encodeURIComponent(q)}`, auth(token)).then(r => r.data),
  myFriends:      (token)               => axios.get(`${API}/friends`, auth(token)).then(r => r.data),
  myRequests:     (token)               => axios.get(`${API}/friends/requests`, auth(token)).then(r => r.data),
  requestFriend:  (userId, token)       => axios.post(`${API}/friends/request`, { user_id: userId }, auth(token)).then(r => r.data),
  friendAction:   (userId, action, token) => axios.post(`${API}/friends/${userId}/${action}`, {}, auth(token)).then(r => r.data),

  // Phase B — DMs
  dmThreads:      (token)               => axios.get(`${API}/dm/threads`, auth(token)).then(r => r.data),
  dmStart:        (userId, token)       => axios.post(`${API}/dm/start`, { user_id: userId }, auth(token)).then(r => r.data),
  dmList:         (tid, token)          => axios.get(`${API}/dm/threads/${tid}/messages`, auth(token)).then(r => r.data),
  dmSend:         (tid, body, token)    => axios.post(`${API}/dm/threads/${tid}/messages`, body, auth(token)).then(r => r.data),
  dmRead:         (tid, token)          => axios.post(`${API}/dm/threads/${tid}/read`, {}, auth(token)).then(r => r.data),
};

// Helper to derive a usable URL for an attachment path returned by the upload endpoint.
export const attachmentUrl = (path) => `${API}/uploads/${path}`;
